const ClientInitiativesSection = () => {
  return (
    <section className="bg-white py-10 sm:py-12 md:py-16 lg:py-16">
      <div className="max-w-[900px] mx-auto px-5 sm:px-6 md:px-8 text-center">
        <span className="section-label mb-3 sm:mb-4 inline-block text-xs sm:text-sm">
          What We Did
        </span>
        <h2 className="font-display text-3xl sm:text-[36px] md:text-[42px] leading-tight font-bold text-brand-navy">
          Our Client-Focused Initiatives
        </h2>
        <figure className="my-6 sm:my-8">
          <blockquote className="quote-text text-base sm:text-lg md:text-xl">
            <p>"An expert is someone who knows some of the worst mistakes that can be made in his subject, and how to avoid them."</p>
          </blockquote>
          <figcaption className="quote-attribution mt-3 sm:mt-4 text-sm">
            - Werner Heisenberg
          </figcaption>
        </figure>
        <p className="text-text-dark text-sm sm:text-base md:text-lg leading-[1.8]">
          With over 15 years of combined experience in the manpower and staffing sector, IMMACULATE has a deep understanding of the opportunities and challenges of the business. Our impeccable services are tailored to ensure that your business thrives by utilizing our skilled staff, who have specialized training and the necessary skill sets to perform a job. Our comprehensive database allows us to match qualified staff with your specific business needs.
        </p>
      </div>
    </section>
  );
};

export default ClientInitiativesSection;